import BarcodeIcon from "@assets/images/barcode_svg.svg";
import motorIcon from "@assets/images/motor-1.svg";
import { Box, Button, IconButton, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBack, EventAvailable } from "@material-ui/icons";
import PageHeaderSaleor from "@saleor/components/PageHeader";
import Skeleton from "@saleor/components/Skeleton";
import { RiderDispatchBatch_riderDispatchBatch } from "@saleor/dispatch/types/RiderDispatchBatch";
import { sectionNames } from "@saleor/intl";
import moment from "moment-timezone";
import * as React from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

interface PageHeaderProps {
  onBack: () => void;
  tripInformation: RiderDispatchBatch_riderDispatchBatch;
  loading: boolean;
  generateTripTicket: () => void;
}

const useStyles = makeStyles(
  () => ({
    root: {
      marginBottom: "18px"
    },
    svgIcon: {
      display: "flex",
      fontSize: "30px",
      marginRight: "5px"
    },
    tripDetails: {
      "& > *": {
        marginRight: "1em"
      },
      "& span": {
        alignItems: "center",
        fontSize: "18px",
        fontWeight: 500
      },
      display: "flex"
    }
  }),
  {
    name: "TripInfo-PageHeader"
  }
);

const PageHeader: React.FC<PageHeaderProps> = props => {
  const { onBack, tripInformation, loading, generateTripTicket } = props;
  const intl = useIntl();
  const classes = useStyles(props);

  const matches = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  const riderName = tripInformation?.rider
    ? tripInformation?.rider?.firstName + " " + tripInformation?.rider?.lastName
    : "";

  const deliveryDate = tripInformation?.deliveryDate
    ? moment(tripInformation?.deliveryDate).format("LLL")
    : "";

  return (
    <div className={classes.root}>
      <PageHeaderSaleor
        title={
          <span>
            <IconButton aria-label="back" onClick={onBack}>
              <ArrowBack color="primary" />
            </IconButton>
            {intl.formatMessage(sectionNames.tripInformation)}
          </span>
        }
      >
        <Button
          variant="contained"
          color="primary"
          onClick={generateTripTicket}
        >
          Generate Trip Ticket
        </Button>
      </PageHeaderSaleor>

      <Box
        className={classes.tripDetails}
        style={{
          flexDirection: matches ? "column" : "row"
        }}
      >
        <span className={classes.tripDetails}>
          <SVG src={BarcodeIcon} className={classes.svgIcon} />
          <span className={classes.tripDetails}>
            {loading ? <Skeleton /> : tripInformation?.batchCode || ""}
          </span>
        </span>
        <span className={classes.tripDetails}>
          <SVG src={motorIcon} className={classes.svgIcon} />
          <span className={classes.tripDetails}>
            {loading ? <Skeleton /> : riderName}
          </span>
        </span>
        <span className={classes.tripDetails}>
          <EventAvailable color="primary" className={classes.svgIcon} />
          <span className={classes.tripDetails}>
            {loading ? (
              <Skeleton
                style={{
                  width: "100%"
                }}
              />
            ) : (
              deliveryDate
            )}
          </span>
        </span>
      </Box>
    </div>
  );
};

export default PageHeader;
